module.exports = __webpack_public_path__ + "static/img/logo13.5b4d4db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo13.png
// module id = dkO1
// module chunks = 1